/*
 * Define a form page asking the user to decide if they previously reported the issue.
 */
import css from './pages.module.css'
import { yesNoPage } from './choicePage'

export const reportOnBehalfPage = propOverrides => {
  const props = {
    pageId: 'report_on_behalf_page',
    fieldName: 'report_on_behalf',
    label: 'Are you reporting on behalf of someone else?',
    className: css.choices,
    labelClassName: css.largeLabel,
    ...propOverrides
  }

  return yesNoPage({ ...props })
}
